import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { getCouponUserList } from '@/api/coupon';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "eventCouponId", void 0);
    _defineProperty(_this, "listLoading", false);
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "list", []);
    _defineProperty(_this, "listQuery", {
      id: 1,
      page: 1,
      size: 5
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.getList();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "filterCouponType",
    value: function filterCouponType(couponType) {
      if (couponType === 1) {
        return this.$t('coupon.list.type.welcomeCoupon');
      }
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.listLoading = true;
              _context2.p = 1;
              if (!(this.eventCouponId !== 0)) {
                _context2.n = 3;
                break;
              }
              this.listQuery.id = this.eventCouponId;
              _context2.n = 2;
              return getCouponUserList(this.listQuery);
            case 2:
              data = _context2.v;
              this.list = data.list;
              this.total = data.total_count;
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              this.listLoading = false;
            case 5:
              this.listLoading = false;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "eventCouponId", void 0);
__decorate([Watch('eventCouponId')], default_1.prototype, "getList", null);
default_1 = __decorate([Component({
  name: 'UserList',
  components: {
    Pagination: Pagination
  }
})], default_1);
export default default_1;